import { Component } from "@angular/core";


@Component({
  selector: 'changelog',
  templateUrl: './changelog.component.html'
})

export class Changelog {

}
